/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthenticationLayout } from "@src/components/AuthenticationLayout";
import { SignUpLogo } from "./SignUpLogo";
import { SelectDomainType } from "@src/components/SelectDomainType";
import {
  AppAlert,
  ConnectButton,
  SocialProvider,
  RecaptchaTerm,
} from "@advapacs/common";
import axios from "axios";
import { openWindowOpenOauthURL } from "@src/utils/utils";

export const SignUp: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [socialErrorMessage, setSocialErrorMessage] = useState(null);

  // social login
  const handleSigninWithProvider = async (provider: string) => {
    try {
      const rs = await axios.get(`/auth/oauth/redirect/${provider}/signup`);
      openWindowOpenOauthURL(rs?.data?.redirectTo);
    } catch (error) {
      setSocialErrorMessage(error?.response?.data);
    }
  };

  return (
    <AuthenticationLayout>
      <div className="mb-0">
        <SignUpLogo t={t} />

        <SelectDomainType
          isOrg={false}
          onIndividualClick={() => {}}
          onOrgClick={() => {
            navigate("/Signup/Organisation");
          }}
        />
        <ConnectButton
          lable="Sign up"
          className="d-block w-100 m-b-sm"
          type={SocialProvider.GOOGLE}
          onConnect={() => {
            // redirect to google oauth to get information
            // to send callback new steps before signup new accounts.
            handleSigninWithProvider(SocialProvider.GOOGLE);
          }}
        />

        <ConnectButton
          lable="Sign up"
          className="d-block w-100 m-b-sm"
          type={SocialProvider.MICROSOFT}
          onConnect={() => {
            // redirect to google oauth to get information
            // to send callback new steps before signup new accounts.
            handleSigninWithProvider("azure");
          }}
        />

        <div className="middle-line p-t-xxs">
          <span className="text-muted">OR</span>
        </div>

        <button
          onClick={() => {
            navigate("/Signup/Individual");
          }}
          className="btn btn-primary w-100 m-b-sm"
        >
          {t("signup_width_email")}
        </button>

        {socialErrorMessage && (
          <AppAlert.ErrorAlert
            error={socialErrorMessage}
            dismissible
            onClose={() => {
              setSocialErrorMessage(null);
            }}
          />
        )}

        <RecaptchaTerm className="m-t-xxs" />
      </div>
    </AuthenticationLayout>
  );
};
